<template>
  <div class="all-wrapper menu-side with-pattern">

    <div class="auth-box-w row col-lg-3">
      <div class="logo-w col-lg-12">
        <a class="logoDesktop">
          <img alt=""
               src="@/assets/img/logo.png"></a>
        <a class="logoMobile">
          <img alt=""
               src="@/assets/img/logo-turasistan.png"></a>
      </div>
      <div class="col-12"> <vue-progress-bar style="position: relative !important;"/></div>
      <div class="col-lg-12 "
           style="    display: flex;    display: flex;padding-top: 1rem;">
        <router-view />
      </div>

    </div>
  </div>
</template>
<script>
export default {
	name: 'auth-layout',
	created () {
		// document.body.classList.add('auth-wrapper')
	},
	destroyed () {
	  // document.body.classList.remove('auth-wrapper')
	}
}
</script>
<style scoped>

  .auth-box-w .logo-w{
    float: left;
    position: absolute;
    top: -13.5ch;
    left: 0vh;
  }
  .container__input{
   border: none !important;
   height: 35px !important;
  }
  .container__form{
    border-bottom:1px solid #d9d9d9;
  }
  .container__input:focus{
    border:1px solid rgba(255,87,34,.2) !important;
  }

</style>



// WEBPACK FOOTER //
// src/layouts/auth/index.vue